import { render, staticRenderFns } from "./28.vue?vue&type=template&id=48a2be05&scoped=true&"
var script = {}
import style0 from "./28.vue?vue&type=style&index=0&id=48a2be05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a2be05",
  null
  
)

export default component.exports